<template>
  <div class="mangement_course" ref="mainTable">
    <a-table :data-source="tableData" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id">
      <a-table-column title="课程类别名称" key="categoryName" dataIndex="categoryName">
        <template slot-scope="text, record">
          <a-input v-model="record.categoryName" v-if="record.edit" />
          <span v-else>{{ record.categoryName }}</span>
        </template>
      </a-table-column>
      <a-table-column title="所属公司" key="companyId" dataIndex="companyId" v-if="userRole=='youwei_admin'">
        <template slot-scope="text, record">
          {{deptObj[record.companyId]?deptObj[record.companyId].title:''}}
        </template>
      </a-table-column>
      <a-table-column title="课程封面" key="coverUrl" dataIndex="coverUrl">
        <template slot-scope="text, record, index">
          <img style="width: 40px; height: 30px; cursor: pointer" :src="record.tempUrl || record.coverUrl"
            v-if="record.coverUrl" @click="previewImg(record.tempUrl || record.coverUrl)" />
          <a-button type="link" v-if="record.coverUrl && record.edit" @click="changeImg(index)"
            :loading="record.isloading">
            重新上传
          </a-button>
        </template>
      </a-table-column>
      <a-table-column title="标签颜色" key="cssClass" dataIndex="cssClass">
        <template slot-scope="text, record, index">
          <div class="color_box" :style="{ background: record.cssClass }"
            @click="record.edit ? selectColor($event, index) : ''"></div>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="changeInfo(index)" v-if="!record.edit"> 编辑 </a-button>
          <a-button type="link" @click="commitInfo(index)" v-if="record.edit"> 确定 </a-button>
        </template>
      </a-table-column>
    </a-table>
    <div class="picker_Box" :style="{ top: positionY + 'px', left: positionX + 'px' }">
      <colorPicker v-model="selectColorCss" v-on:change="headleChangeColor" ref="colorPicker"></colorPicker>
    </div>
    <a-table bordered :data-source="addData" :scroll="{ y: 66 }" :pagination="false" rowKey="oid" :showHeader="false"
      class="addTable">
      <a-table-column title="课程类别名称" key="categoryName" dataIndex="categoryName">
        <template slot-scope="text, record">
          <a-input v-model="record.categoryName" placeholder="新增行" style="max-width: 210px" />
        </template>
      </a-table-column>
      <a-table-column title="所属公司" key="companyId" dataIndex="companyId" v-if="userRole=='youwei_admin'">
        <template slot-scope="text, record">
          <a-tree-select style="width:210px" v-model="record.companyId" allowClear :treeData="deptLists" tree-checkable
            :show-checked-strategy="SHOW_PARENT" placeholder="所属公司" :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1" @change="deptchange">
          </a-tree-select>
        </template>
      </a-table-column>
      <a-table-column title="课程封面" key="coverUrl" dataIndex="coverUrl">
        <template slot-scope="text, record">
          <img style="width: 40px; height: 30px; cursor: pointer" :src="record.tempUrl || record.coverUrl"
            v-if="record.coverUrl" @click="previewImg(record.tempUrl || record.coverUrl)" />
          <a-button type="link" @click="changeImg(-1)" :loading="record.isloading"> 上传封面图 </a-button>
        </template>
      </a-table-column>
      <a-table-column title="标签颜色" key="cssClass" dataIndex="cssClass">
        <template slot-scope="text, record">
          <div class="color_box" :style="{ background: record.cssClass }" @click="selectColor($event, -1)"></div>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="addInfo(index)"> 新增 </a-button>
        </template>
      </a-table-column>
    </a-table>
    <input ref="uploadImage" type="file" style="width: 0; height: 0; opacity: 0" @change="selectImg" />
  </div>
</template>

<script>
import { getCategoryList, getFileUrl, uploadFile, editcategory, addcategory } from '../../../../api/course'
import { tree_all } from '../../../../api/purchase'
import axios from 'axios'
import { compressImg } from '@/utils/util'
export default {
  data() {
    return {
      tableData: [],
      tableScrollY: 300,
      selectIndex: '',
      addData: [
        {
          oid: 1,
          categoryName: '',
          companyId: undefined,
          coverUrl: '',
          cssClass: '',
        },
      ],
      userInfo: {},
      positionX: 0,
      positionY: 0,
      selectColorCss: '',
      selectColorIndex: '',
      deptLists: [],
      deptObj: {},
      userRole: '',
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
    })
  },
  methods: {
    init() {
      this.get_lis()
      this.getDeptLists()
      this.$nextTick((res) => {
        this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
      })
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        let deptLists = []
        let deptObj = {}
        if (this.userRole == "youwei_admin") {
          let data = res.data[0]
          for (let i = 0; i < data.length; i++) {
            deptObj[data[i].deptId] = data[i]
          }
          console.log(deptObj);
          this.deptObj = deptObj
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          res.data[0].forEach((item) => {
            if (item.deptId == this.userInfo.companyId) {
              deptLists = item.children
              this.deptLists = deptLists
            }
          })
        }
      })
    },
    headleChangeColor(e) {
      if (this.selectColorIndex >= 0) {
        this.tableData[this.selectColorIndex].cssClass = e
      } else {
        this.addData[0].cssClass = e
      }
    },
    selectColor(e, index) {
      this.selectColorIndex = index
      if (index >= 0) {
        this.selectColorCss = this.tableData[index].cssClass
      } else {
        this.selectColorCss = this.addData[0].cssClass
      }
      let rect = this.$refs.mainTable.getBoundingClientRect()
      this.positionX = e.pageX - rect.left
      this.positionY =
        (e.pageY + 280 > document.body.clientHeight ? document.body.clientHeight - 280 : e.pageY) - rect.top
      let pickerBtn = this.$refs.colorPicker.$refs.colorPicker.firstElementChild
      pickerBtn.dispatchEvent(new MouseEvent('click'))
      //
    },
    addInfo(index) {
      if (!this.addData[0].categoryName) {
        return this.$message.error('请输入课程类别名称')
      } else if (!this.addData[0].coverUrl) {
        return this.$message.error('请上传课程封面图片')
      } else if (!this.addData[0].cssClass) {
        return this.$message.error('请选择课程标签颜色')
      }
      if (this.userRole == 'youwei_admin') {
        let lists = []
        if (this.addData[0].companyId) {
          for (let i = 0; i < this.addData[0].companyId.length; i++) {
            let item = JSON.parse(JSON.stringify(this.addData[0]))
            item.companyId = this.addData[0].companyId[i]
            lists.push(item)
          }
        } else {
          lists.push(this.addData[0])
        }
        let request_lis = []
        for (let i = 0; i < lists.length; i++) {
          request_lis.push(new Promise((reslove, reject) => {
            addcategory(lists[i]).then((res) => {
              reslove(res)
            })
          }))
        }
        Promise.all(request_lis).then(res => {
          let reject_num = 0
          for (let i = 0; i < res.length; i++) {
            if (res[i].code != 200) {
              reject_num += 1
            }
          }
          if (reject_num) {
            this.$message.error(reject_num + '个课程设置失败，请联系管理员')
          } else {
            this.$message.success('设置成功')
          }
          this.addData[0].companyId = undefined
          this.addData[0].categoryName = ''
          this.addData[0].coverUrl = ''
          this.addData[0].cssClass = ''
          this.get_lis()
        })
      } else {
        addcategory(this.addData[0]).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('添加成功')
          this.addData[0].categoryName = ''
          this.addData[0].coverUrl = ''
          this.addData[0].cssClass = ''
          this.get_lis()
        })
      }
    },
    changeInfo(index) {
      this.$set(this.tableData[index], 'edit', true)
    },
    commitInfo(index) {
      editcategory(this.tableData[index]).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.get_lis()
      })
    },
    changeImg(index) {
      this.selectIndex = index
      this.$refs.uploadImage.dispatchEvent(new MouseEvent('click'))
    },
    selectImg(e) {
      if (e.target.value) {
        let file = e.target.files[0]
        e.target.value = ''
        if (file.type.indexOf('image') == -1) {
          return this.$message.error('只能上传图片文件')
        }
        if (this.selectIndex >= 0) {
          this.$set(this.tableData[this.selectIndex], 'isloading', true)
        } else if (this.selectIndex == -1) {
          this.$set(this.addData[0], 'isloading', true)
        }
        if (file.size > 1024 * 200) {
          compressImg(file, 1024 * 200).then((res) => {
            this.uploadImg(res, file.name).then((res) => {
              if (this.selectIndex >= 0) {
                this.tableData[this.selectIndex].coverUrl = res.data.url[0].path
                this.tableData[this.selectIndex].tempUrl = res.data.url[0].url
                this.tableData[this.selectIndex].types = res.data.url[0].types
                this.tableData[this.selectIndex].tempId = res.data.url[0].tempId
                this.$set(this.tableData[this.selectIndex], 'isloading', false)
              } else if (this.selectIndex == -1) {
                this.addData[0].coverUrl = res.data.url[0].path
                this.addData[0].tempUrl = res.data.url[0].url
                this.addData[0].types = res.data.url[0].types
                this.addData[0].tempId = res.data.url[0].tempId
                this.$set(this.addData[0], 'isloading', false)
              }
            })
          })
        } else {
          this.uploadImg(file).then((res) => {
            if (this.selectIndex >= 0) {
              this.tableData[this.selectIndex].coverUrl = res.data.url[0].path
              this.tableData[this.selectIndex].tempUrl = res.data.url[0].url
              this.tableData[this.selectIndex].types = res.data.url[0].types
              this.tableData[this.selectIndex].tempId = res.data.url[0].tempId
              this.$set(this.tableData[this.selectIndex], 'isloading', false)
            } else if (this.selectIndex == -1) {
              this.addData[0].coverUrl = res.data.url[0].path
              this.addData[0].tempUrl = res.data.url[0].url
              this.addData[0].types = res.data.url[0].types
              this.addData[0].tempId = res.data.url[0].tempId
              this.$set(this.addData[0], 'isloading', false)
            }
          })
        }
      }
    },
    uploadImg(file, name) {
      let _this = this
      let timeTemp = Date.now()
      let params = new FormData()
      if (name) {
        params.append('file', file, name)
      } else {
        params.append('file', file)
      }
      params.append('path', 'cover' + this.userInfo.companyId + '/')
      params.append('types', 'course-cover')
      params.append('delFlag', 2)
      params.append('tempId', timeTemp)
      axios.defaults.headers['token'] = localStorage.getItem('Access-Token').replace(/"/g, '')
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_BASE_URL + '/file/file/upload',
          method: 'post',
          data: params,
        }).then((res) => {
          if (res.data && res.data.code && res.data.code != 200) {
            return _this.$message.error(res.data.msg)
          }
          _this.$message.success('上传成功')
          res.data.data.url[0].types = 'course-cover'
          res.data.data.url[0].tempId = timeTemp
          resolve(res.data)
        })
      })
    },
    get_lis() {
      getCategoryList().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.tableData = res.data.list
      })
    },
    previewImg(e) {
      window.open(e)
    },
  },
}
</script>

<style scoped lang="less">
.mangement_course {
  width: 100%;
  height: 100%;
  position: relative;
  .addTable {
    /deep/ .ant-table-body {
      overflow: hidden !important;
    }
  }
  .picker_Box {
    width: 0;
    height: 0;
    position: absolute;
    z-index: 9;
    /deep/ .colorBtn {
      width: 0px !important;
      height: 0px !important;
      cursor: pointer;
    }
  }
  .color_box {
    width: 40px;
    height: 20px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
}
</style>